import { PayloadAction, Reducer, createSlice } from "@reduxjs/toolkit";
import { GatedContentStatus, StripeConnectAccountState } from "./types";
import {
    StripeAccount,
    StripeAccountsDetails
} from "@switcherstudio/switcher-api-client";

const initialState: StripeConnectAccountState = {
    account: null,
    details: null,
    isLoading: true,
    gatedContentStatus: GatedContentStatus.FEATURE_DISABLED,
    isPollingStripeAccounts: false,
    startedPollingAt: null,
    pollingTimeout: 10 * 1000 // 10 seconds
};

export const stripeConnectAccount = createSlice({
    name: "stripeConnectAccount",
    initialState,
    reducers: {
        /** Set the stripe accounts. */
        setStripeAccount: (
            state,
            { payload }: PayloadAction<StripeAccount>
        ) => {
            state.account = payload;
        },
        /** Set the stripe accounts details. */
        setStripeAccountDetails: (
            state,
            { payload }: PayloadAction<StripeAccountsDetails>
        ) => {
            state.details = payload;
        },
        /** Set the gated content status. */
        setGatedContentStatus: (
            state,
            { payload }: PayloadAction<GatedContentStatus>
        ) => {
            state.gatedContentStatus = payload;
        },
        /** Set the loading status. */
        setLoadingStripeAccounts: (
            state,
            { payload }: PayloadAction<boolean>
        ) => {
            state.isLoading = payload;
        },
        /** Set the polling stripe accounts status. */
        setPollingStripeAccounts: (
            state,
            { payload }: PayloadAction<boolean>
        ) => {
            state.isPollingStripeAccounts = payload;
        },
        /** Set the polling stripe accounts status. */
        setPollingStartedAtToNow: (state) => {
            state.startedPollingAt = new Date();
        },
        /** Set the polling stripe accounts status. */
        resetPollingStartedAt: (state) => {
            state.startedPollingAt = null;
        },
        /** Set the polling stripe accounts status. */
        resetStripeConnectAccount: () => initialState
    }
});

export const {
    setStripeAccount,
    setStripeAccountDetails,
    setGatedContentStatus,
    setLoadingStripeAccounts,
    setPollingStripeAccounts,
    resetStripeConnectAccount,
    setPollingStartedAtToNow,
    resetPollingStartedAt
} = stripeConnectAccount.actions;

export default stripeConnectAccount.reducer as Reducer<StripeConnectAccountState>;
